import graphql__530cd3a605d7302daa74 from "./__generated__/UserGroups_user.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const UserGroups = props => {
  const { groups } = props.user;

  if (!groups || !groups.length) return null;

  return (
    <div className="user-groups">
      {groups.map(group => (
        <div key={group.id} className="user-group">
          <span
            className="small font-weight-bold"
            style={{
              borderColor: group.usersGroup.backgroundColor,
              color: group.usersGroup.backgroundColor
            }}
          >
            {group.usersGroup.name}
          </span>
          <span
            className="small padding-left-xs margin-left-xs small"
            style={{
              borderLeft: "1px solid lightgray"
            }}
          >
            {group.statusName}
          </span>
        </div>
      ))}
    </div>
  );
};

export default createFragmentContainer(UserGroups, {
  user: graphql__530cd3a605d7302daa74
});
